<template>
  <div class="ac-body-container branding-container">
    <div class="ac-row-container">
      <div class="flex-column-1">
        <UploadLogo
          :adminRole="adminRole"
          :primaryColor="primaryColor"
          :logoPreview="logoPreview"
          :cropperPreview="cropperPreview"
          :onChange="onChange"
          :selectedImage="selectedImage"
          :handleEdit="handleEdit"
          :errorObj="errorObj"
        />
        <PrimaryColor
          :adminRole="adminRole"
          :primaryColor="primaryColor"
          :onChange="onChange"
        />
        <div
          v-if="isSmacAdmin"
          class="ac-content-wrapper"
        >
          <div class="header">
            App Icon & Custom Name
          </div>
          <div class="ac-toggle-container">
            <button
              type="button"
              :class="[showCustomApp ? 'active' : null]"
              @click="onChange('showCustomApp', true)"
            >
              On
            </button>
            <div class="ac-toggle-divider" />
            <button
              type="button"
              :class="[!showCustomApp ? 'active' : null]"
              @click="onChange('showCustomApp', false)"
            >
              Off
            </button>
          </div>
        </div>
        <AppIcon
          v-if="showCustomApp"
          :adminRole="adminRole"
          :selectedImage="selectedImage"
          :appIconPreview="appIconPreview"
          :errorObj="errorObj"
        />
        <AppName
          v-if="showCustomApp"
          :appName="appName"
          :onChange="onChange"
        />
      </div>
      <div class="ac-centered-container flex-1">
        <HomeScreenPreview
          :primaryColor="primaryColor"
          :logoPreview="logoPreview"
        />
        <WelcomeEmailPreview
          :currentCorporation="currentCorporation"
          :primaryColor="primaryColor"
          :logoPreview="logoPreview"
        />
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-advanced-cropper/dist/style.css';

import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import UploadLogo from '@shared/components/partnerSettings/branding/UploadLogo.vue';
import PrimaryColor from '@shared/components/partnerSettings/branding/PrimaryColor.vue';
import AppIcon from '@shared/components/partnerSettings/branding/AppIcon.vue';
import AppName from '@shared/components/partnerSettings/branding/AppName.vue';
import HomeScreenPreview from '@shared/components/partnerSettings/branding/HomeScreenPreview.vue';
import WelcomeEmailPreview from './branding/WelcomeEmailPreview.vue';

export default {
  name: 'BrandingView',
  components: {
    UploadLogo,
    PrimaryColor,
    AppIcon,
    AppName,
    WelcomeEmailPreview,
    HomeScreenPreview,
  },
  mixins: [partnerSettingsMixin],
  props: {
    currentCorporation: Object,
    primaryColor: String,
    logoPreview: String,
    cropperPreview: String,
    appIconPreview: String,
    appName: String,
    onChange: Function,
    selectedImage: Function,
    handleEdit: Function,
    showCustomApp: Boolean,
    errorObj: Object,
  },
};
</script>

<style lang="scss">

.branding-container {
  .ac-row-container {
    display: flex;
    justify-content: space-between;
    max-width: 100%!important;
  }

  .header {
    font-size: 16px;
    font-weight: 600;
  }
  .sub-header {
    font-size: 16px;
    font-weight: 400;
    color: $N60;
    margin-bottom: 24px;
  }
  .ac-upload-wrapper {
    width: 49%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
  }
  .ac-upload-container {
    display: flex;
    background: $N10;
    border-radius: 6px;
    height: 300px;
    padding: 0 24px;
    max-width: 400px;
    .ac-loading-container {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .ac-toggle-container {
    width: 245px;
    background: #ECEDEE;
    border-radius: 8px;
    padding: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ac-toggle-divider {
      width: 1px;
      height: 24px;
      background-color: #C3C6CB;
      margin: 0 2px;
    }
    button {
      height: 32px;
      width: 49%;
      border-radius: 6px;
      font-size: 0.75rem;
      font-weight: 500;
      &.active {
        background: $WHITE;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.10);
      }
    }
  }

  .dropbox-form {
    display: flex;
    .dropbox-container {
      display: flex;
      border-radius: 5px;
      cursor: pointer;
      position: relative;
      align-items: center;
      justify-content: center;
      border: 1px solid $N30;
      padding: 8px 16px;
      .db-input {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        cursor: pointer;
      }
      .db-header {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 0.875rem;
        font-weight: 500;
        text-align: center;
        white-space: pre;
        .blue-underline {
          text-decoration: underline;
          color: $NBLUE100;
          font-weight: 600;
        }
        .upload-icon {
          width: 25px;
          height: 24px;
          object-fit: contain;
        }
      }
      .db-error-container {
        display: flex;
        flex-direction: column;
        .blue-underline {
          text-decoration: underline;
          color: $NBLUE100;
          font-weight: 600;
        }
      }
      .db-error {
        font-weight: 500;
        color: $TOMATO100;
        text-align: center;
        white-space: pre;
        min-width: 266px;
        min-height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .ac-content-wrapper:not(:last-child) {
    margin-bottom: 50px;
  }
  .ac-centered-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .ac-preview-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .ac-logo-preview-container {
      border-radius: 9px;
      width: 183px;
      height: 183px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;
      img {
        width: 100%;
      }
    }
    .ac-change-image-btn {
      background-color: $NBLUE100;
      width: 183px;
      height: 36px;
      color: $WHITE;
      font-size: 0.875rem;
      font-weight: 600;
      border-radius: 4px;
      padding: 0 12px;
      cursor: pointer;
      white-space: nowrap;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .button-dropbox-container {
    position: relative;
    width: 183px;
    cursor: pointer;
    .db-input {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      opacity: 0;
      cursor: pointer;
    }
  }

  .ac-upload-btn {
    background-color: $NBLUE100;
    color: $WHITE;
    font-size: 0.875rem;
    font-weight: 600;
    border-radius: 4px;
    padding: 6px 12px;
    margin-bottom: 24px;
    white-space: nowrap;
  }

  .ac-example-container {
    display: flex;
    align-items: flex-start;
    margin-bottom: 24px;
    .example-img {
      width: 151px;
      object-fit: contain;
      margin-right: 50px;
    }
    .smac-logo-img {
      width: 110px;
      object-fit: contain;
    }
    .ac-example-text {
      font-size: 0.875rem;
    }
  }

  .ac-text-input-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 50%;
    .ac-text-counter {
      font-size: 0.875rem;
      margin-top: 2px;
      color: $N80;
      font-weight: 600;
    }
  }
}
</style>
